import styled from "styled-components";
import { colors, screenSizes } from "../../styles/theme";
interface HeaderProps {
  scrolled: boolean;
  backColor?: boolean;
  isScrolling?: boolean;
}
export const HeaderMainWrapper = styled.div<HeaderProps>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 89;
  width: 100%;
  background: ${(props) => (props.scrolled ? "rgba(253, 249, 238, 1)" : "transparent")};
  padding: ${(props) => (props.scrolled ? 0 : "1rem")};
  color: #fff;
  transition: all 0.5s;
`;
export const HeaderWrapper = styled.header`
  display: flex;
  align-items: center;
  height: 80px;
  z-index: 100;
  background-color: ${colors.white};
`;

export const HeaderContainer = styled.header<HeaderProps>`
  input {
    background-color: ${(props) => ((props.backColor) ? "transparent" : "transparent")};
    caret-color: ${(props) => (props.isScrolling ? "#000" :(props.scrolled) ? "white" : "black")};
    color: ${(props) => (props.isScrolling ? "#000" : (props.scrolled) ? "white" : "black")};
  }
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${colors.dark};
  background: linear-gradient(
    319.67deg,
    transparent -9.22%,
    transparent 77.04%
  );
  border: ${(props) => (props.scrolled ? "1px solid #FFFFFF1A" : "1px solid #091C001A")};
  padding: 0.6rem 1.5rem;
  z-index: 99;
  .header_logo {
    flex: 1 1 0;
    position: relative;
    z-index: 99;
  }
  .menu_right_bar {
    display: flex;
    align-items: center;
    flex: 1 1 0;
    gap: 30px;
    justify-content: space-between;
    margin-left: -5%;
    @media (max-width: ${screenSizes.L}px) {
    justify-content: end;
    margin-left: 0;
  }
  }
  @media (max-width: ${screenSizes.L}px) {
    flex-direction: row;
    padding: 1rem;
    gap: 10px;
  }
`;

export const HeaderLogo = styled.img`
  cursor: pointer;

  @media (max-width: ${screenSizes.S}px) {
    max-width: 100px;
  }
`;

export const Menu = styled.ul<any>`
  list-style: none;
  .contact_menu {
    justify-content: end;
    margin-bottom: 5rem;
    a {
      border: 2px solid #fff;
      max-width: 180px;
      height: 180px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      font-size: 18px;
      transition: all 0.3s;
      &:hover {
        border: 2px solid #ffffff20;
        background: #ffffff20;
      }
    }
  }
  .bottom_header {
    ul {
      padding-left: 0;
      list-style: none;
      padding-top: 25px;
      display: flex;
      justify-content: space-between;
      border-top: 1px solid #ffffff1a;
      li {
        color: #ffffff80;
        a {
          color: #ffffff;
          text-decoration: underline;
          &:hover {
            color: #ffffff80;
          }
        }
        span {
          margin-inline: 10px;
          @media (max-width: ${screenSizes.L}px) {
            margin-inline: 5px;
          }
        }
      }
      @media (max-width: ${screenSizes.L}px) {
        padding-top: 25px;
        display: block;
        font-size: 14px;
      }
    }
  }
  .two_side_menu {
    display: grid;
    grid-template-columns: 5fr 1fr;
    padding-top: 50px;
    @media (max-width: ${screenSizes.L}px) {
      padding-top: 75px;
      display: block;
    }
  }
  .Open_menu_bar {
    padding-bottom: 40px;
    button {
      border: 2px solid #ffffff20;
      border-radius: 50px;
      background: transparent;
      color: #ffffff;
      margin-right: 20px;
      max-width: 250px;
      width: 100%;
      text-align: left;
      font-weight: 700;
      justify-content: space-between;
      transition: all 0.3s;
      &:hover {
        background: #ffffff20;
      }
      @media (max-width: ${screenSizes.L}px) {
        margin-bottom: 10px;
        max-width: none;
        &:first-child {
        justify-content: center;
        }
      }
    }
    li {
      a {
        color: #fff;
        font-size: 90px;
        font-weight: 400;
        line-height: 110px;
        transition: all 0.3s;
        &:hover {
          color: #ff9d59;
        }
        @media (max-width: ${screenSizes.L}px) {
          font-size: 40px;
          line-height: 55px;
          letter-spacing: -2px;
        }
      }
    }
    p {
      color: #ffffff80;
      font-weight: 400;
      padding: 30px 0;
      @media (max-width: ${screenSizes.L}px) {
        padding: 10px 0;
      }
    }
    @media (max-width: ${screenSizes.L}px) {
      padding-bottom: 0;
    }
  }
  @media (max-width: ${screenSizes.L}px) {
    grid-gap: 24px;
    column-gap: 20px;
    padding: 1rem;
    justify-content: normal;
  }
  @keyframes slideDown {
    from {
      transform: translateY(-100%);
    }
    to {
      transform: translateY(0);
    }
  }
  display: ${(props) => (props.open ? "flex" : "none")};
  justify-content: space-between;
  position: fixed;
  flex-direction: column;
  background: linear-gradient(319.67deg, #091c00 -9.22%, #121511 77.04%);
  top: 0;
  margin-top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 4rem 5rem 2rem;
  animation: underLine 0.5s ease-in-out;
  overflow: hidden;
  z-index: -1;
`;

export const MenuItem = styled.li`
  display: flex;
  align-items: end;
  font-family: "Sora", sans-serif;
  font-weight: 600;
  font-size: 18px;
  cursor: pointer;
  position: relative;
  svg {
    fill: #1e440b;
  }
  a {
    color: #fff;
    white-space: nowrap;
    word-break: keep-all;
    text-decoration: none;
    @media (max-width: ${screenSizes.L}px) {
      color: #fff;
    }
    &:hover {
      color: #ff9d59 !important;
    }
  }
  @media (max-width: ${screenSizes.XL}px) {
    font-size: 14px;
    svg {
      fill: #fff;
    }
  }

  @keyframes underLine {
    from {
      transform: scaleY(0);
      transform-origin: top;
    }
    to {
      transform: scaleY(1);
      transform-origin: top;
    }
  }

  .profile-picture {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    overflow: hidden;
  }

  .profile-picture img {
    width: 100%;
    height: 100%;
  }
  .profile-dropdown {
    max-width: 200px;
    position: absolute;
    top: 100%;
    left: 0;
    border-radius: 5px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    z-index: 1;
    padding: 10px 10px;
  }

  .profile-dropdown div {
    text-align: start;
    width: 100%;
    padding: 10px 8px;
    font-weight: 400;
    font-size: 14px;
    text-transform: none !important;
  }

  .profile-dropdown div:first-child {
    border-bottom: 1px solid #3b3263;
  }

  .profile-dropdown div:nth-child(2) {
    border-bottom: 1px solid #3b3263;
  }
  .profile-dropdown button {
    background-color: transparent;
    border: none;
    cursor: pointer;
    color: red;
  }
`;

export const MenuIcon = styled.a<{ scrolled: boolean; baseUrl: string }>`
  margin-right: 20px;
  display: none;
  font-size: 24px;
  cursor: pointer;
  align-items: center;
  position: relative;
  right: 0;
  top: 0;
  width: 28px;
  height: 10px;
  display: inline-block;
  visibility: visible;
  opacity: 1;
z-index: 200;
  span {
    position: absolute;
    display: block;
    height: 2px;
    width: 100%;
    background-color: ${(props) =>
      props.baseUrl === "/marketplace"
        ? props.scrolled
          ? "#091C00"
          : "#fff"
        : props.scrolled
        ? "#091C00"
        : "#fff"}; // Default white color for other pages without scroll
    -webkit-transition: top 0.2s 0.25s, opacity 0.2s 0.25s,
      -webkit-transform 0.2s 0s;
    transition: top 0.2s 0.25s, opacity 0.2s 0.25s, -webkit-transform 0.2s 0s;
    -o-transition: top 0.2s 0.25s, opacity 0.2s 0.25s, transform 0.2s 0s;
    transition: top 0.2s 0.25s, opacity 0.2s 0.25s, transform 0.2s 0s;
    transition: top 0.2s 0.25s, opacity 0.2s 0.25s, transform 0.2s 0s,
      -webkit-transform 0.2s 0s;
  }

  span:nth-child(1) {
    top: 0;
  }
  span:nth-child(2) {
    top: 8px;
  }

  &.active span {
    -webkit-transition: background 0.2s, top 0.2s, opacity 0.2s,
      -webkit-transform 0.2s 0.25s;
    transition: background 0.2s, top 0.2s, opacity 0.2s,
      -webkit-transform 0.2s 0.25s;
    -o-transition: background 0.2s, top 0.2s, opacity 0.2s, transform 0.2s 0.25s;
    transition: background 0.2s, top 0.2s, opacity 0.2s, transform 0.2s 0.25s;
    transition: background 0.2s, top 0.2s, opacity 0.2s, transform 0.2s 0.25s,
      -webkit-transform 0.2s 0.25s;
    background-color: #fff;
  }

  &.active span:nth-child(2),
  &.active span:nth-child(1) {
    top: 5px;
  }

  &.active span:nth-child(1) {
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
  &.active span:nth-child(2) {
    -webkit-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }
`;

export const ImageContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const BlueTick = styled.img`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 18px !important;
  height: 18px !important;
  overflow: auto !important;
`;

export const StyledWalletButton = styled.button`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  outline: none;
  background-color: #ff9d59 !important;
  padding: 12px 20px;
  color: #fff;
  border-radius: 50px;
  gap: 10px;
  font-size: 16px;
  font-weight: 600;
  span {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
